import { LauncherElementType } from '../../info/launcherElementInfo';
import { createStore } from '../createStore';

interface TrueFalse {
  true?: {};
  false?: {};
}

interface FailReasons {
  unknownError?: {};
  noDiskSpace?: {};
  noPermission?: {};
  noInternet?: {};
}

interface Variants {
  isAppInstalled?: TrueFalse;
  isAppUpdateAvailable?: TrueFalse;
  doesAppNeedRepair?: TrueFalse;
  isAppRunning?: TrueFalse;

  isAnyTaskInProgress?: TrueFalse;
  isInstallTaskInProgress?: TrueFalse;
  isUpdateTaskInProgress?: TrueFalse;
  isRepairTaskInProgress?: TrueFalse;
  isMoveTaskInProgress?: TrueFalse;
  isUninstallTaskInProgress?: TrueFalse;

  isAnyTaskPaused?: TrueFalse;
  isInstallTaskPaused?: TrueFalse;
  isUpdateTaskPaused?: TrueFalse;
  isRepairTaskPaused?: TrueFalse;
  isMoveTaskPaused?: TrueFalse;
  isUninstallTaskPaused?: TrueFalse;

  hasAnyTaskFailed?: TrueFalse;
  hasInstallTaskFailed?: TrueFalse;
  hasUpdateTaskFailed?: TrueFalse;
  hasRepairTaskFailed?: TrueFalse;
  hasMoveTaskFailed?: TrueFalse;
  hasUninstallTaskFailed?: TrueFalse;

  failReason?: FailReasons;
}

export interface LauncherElementData {
  id: string;
  type: LauncherElementType;
  name?: string;
  props: {
    text?: string;
    variable?: string;
    commands?: { type: string; appProcessExtraArgsAsText?: string; linkUrl?: string; popupId?: string }[];
    href?: string;
    src?: string;
    [key: string]: any;
    class: {
      [key: string]: any;
      variants?: Variants;
    };
  };
}

export interface TreeNode {
  id: string;
  children?: TreeNode[];
  index?: number;
  [key: string]: any;
}

export const [LauncherElementsStoreProvider, useLauncherElementsStore] = createStore<Record<string, LauncherElementData>>({});
